// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__sO-qW","description":"MealItem_description__ttZoA","price":"MealItem_price__N0Hyn"};